export default "__VITE_ASSET__hqa74Tzd__"